module.exports = __webpack_public_path__ + "static/media/heroBack4.d654845a.svg";